import { useEffect } from 'react';

export const useClearSessionStorage = () => {
  useEffect(() => {
    const clearSessionStorage = () => {
      sessionStorage.clear();
    };

    window.addEventListener('unload', clearSessionStorage);

    return () => {
      window.removeEventListener('unload', clearSessionStorage);
    };
  }, []);
};
